var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradeRelationShips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0001 41.5C60.3933 41.5 62.3334 39.5599 62.3334 37.1667C62.3334 34.7734 60.3933 32.8333 58.0001 32.8333C55.6068 32.8333 53.6667 34.7734 53.6667 37.1667C53.6667 39.5599 55.6068 41.5 58.0001 41.5Z",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 52.3333C40.3933 52.3333 42.3334 50.3932 42.3334 48C42.3334 45.6068 40.3933 43.6667 38.0001 43.6667C35.6068 43.6667 33.6667 45.6068 33.6667 48C33.6667 50.3932 35.6068 52.3333 38.0001 52.3333Z",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0001 63.1667C60.3933 63.1667 62.3334 61.2266 62.3334 58.8333C62.3334 56.4401 60.3933 54.5 58.0001 54.5C55.6068 54.5 53.6667 56.4401 53.6667 58.8333C53.6667 61.2266 55.6068 63.1667 58.0001 63.1667Z",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8333 50.3333L54.1666 56.5",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1666 39.5L41.8333 45.6667",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeRelationShips);
export default __webpack_public_path__ + "static/media/tradeRelationShips.5b4275efa746532cc3c58f5c0807fc11.svg";
export { ForwardRef as ReactComponent };